export default __webpack_public_path__ + "static/media/pig.2fc5e1a6.svg";